<template>
  <v-container fluid class="d-flex flex-column justify-center height-100-percent">
    <v-row align-content="center">
      <v-col
          cols="12"
          sm="10" offset-sm="1"
          md="8" offset-md="2"
          lg="6" offset-lg="3"
          xl="4" offset-xl="4"
      >
        <v-card elevation="1">
          <v-card-title>
            <img src="/images/acc-logo-rgb.png" alt="America's Call Center" height="100" width="157"
                 class="mx-auto">
          </v-card-title>
          <v-card-text>
            <p class="mt-4">Enter your username and we will email you a link to reset your password.</p>
            <form @submit.prevent @keyup.enter="submit">
              <v-text-field
                  v-model="username"
                  id="username"
                  :error-messages="usernameErrors"
                  label="Username"
                  required
                  filled
                  @blur="$v.username.$touch()"
              ></v-text-field>
              <v-btn
                  class="mr-4"
                  @click="submit"
                  block
                  color="primary"
                  :loading="submitted"
                  :disabled="submitted || $v.$invalid"
              >
                Send Password Reset Link
              </v-btn>
            </form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {validationMixin} from 'vuelidate';
import {minLength, required} from 'vuelidate/lib/validators';
import {mapActions} from "vuex";
import {displayErrors} from '../helpers/AppHelper'

export default {
  mixins: [validationMixin],
  validations: {
    username: {
      required,
      minLength: minLength(3)
    },
  },
  name: 'AppForgotPassword',
  data() {
    return {
      username: '',
      submitted: false,
    }
  },
  computed: {
    usernameErrors() {
      const errors = []
      if (! this.$v.username.$dirty) return errors
      ! this.$v.username.minLength && errors.push('Username must be at least 3 characters long')
      ! this.$v.username.required && errors.push('Username is required.')
      return errors
    },
  },
  methods: {
    ...mapActions({sendForgotPasswordEmail: 'auth/sendForgotPasswordEmail'}),
    submit() {
      if (this.$v.$invalid) {
        return
      }
      this.submitted = true
      this.sendForgotPasswordEmail(this.username)
          .then(_ => {
            this.$router.replace({name: 'forgot-password-sent'})
          })
          .catch((error) => {
            console.log(error)
            displayErrors(error)
          })
          .finally(() => {
            this.submitted = false
          })
    },
  },
}
</script>
